
import { StrategyBaseClass } from './strategy-base-class.js'


export class WhatsappService extends StrategyBaseClass {
  constructor($translate) {
    super($translate);
  }

  getType() {
    return 12;
  }
  getTypeString() {
    return 'whatsapp';
  }
  getAllTasksTypes() {
    return [35];
  }
  getTaskTypeString(taskType) {
    let mapping = {
      35: 'whatsapp/msg'
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType) {
    let mapping = {
      35: 'whatsapp-msg'
    };
    return mapping[taskType];
  }

  getPrivateTaskTypes() {
    return [35];
  }

  canHaveSurveys() {
    return true;
  }

  getEditorConfiguration(isPrivate) {
    return {
      maxMessageLength: 4096,
      'pictureEnabled': true,
      'imageMimeTypes': 'image/jpeg,image/png',
      'videoEnabled': true,
      'fileEnabled': true
    };
  }

  getQuickRepliesElementsConfig() {
    return {
      maxAnswerNb: 11,
      answerLabelMaxLength: 50,
      hasDescription: false,
      canHaveUserVariableInRootQuestion: false,
      hasPhoneEmailAnswerType: false,
      hasUrlAnswerType: false,
      hasTargetAppId: false,
      boxesCanBeTested: false,
      hasPersistentMenu: false,
      hasWelcomeMessage: false,
      videoMimeTypes: 'video/mp4,video/3gpp',
      imageMimeTypes: 'image/jpeg,image/png',
      fileMediaTypes: 'text/plain,application/pdf,application/vnd.ms-powerpoint,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      editorConfiguration: {
        fileEnabled: true,
        hasImageControl: false,
        maxCharsNumber: 4096,
      },
      openSectionsButtonInListMessages: true,
      sendTextAfterButtonChoice: false,
      canSendVideo: true
    };
  }

  getSatisfactionSurveysExpirationHoursOptions() {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  }

  getWhatsappTemplateConfiguration() {
    return {
      maxLength: {
        templateName: 512,
        header: 60,
        body: 1024,
        footer: 60,
        button: 25,
      },
      maxNumber: {
        button: 3,
        placeholders: 5
      }
    };

  }

  static WhatsappFactory($translate) {
    return new WhatsappService($translate);
  }
}
WhatsappService.WhatsappFactory.$inject = ['$translate'];
